export default {
  loading: 'Cargando precios',
  provider: 'Proveedor',
  taxId: 'RFC',
  amount: 'Monto',
  actions: 'Acciones'
}
